.filePicker {
  isolation: isolate;
  .toolbar {
    mix-blend-mode: difference;
  }
}
